import React, { useEffect, useState, useRef } from "react";
import { motion } from "framer-motion";
import "./Homeservice.css";

import emp1 from "../Imges/offsetPrinting.png";
import emp3 from "../Imges/WebPrinting.jpeg";
import emp4 from "../Imges/DigitalPrinting.jpg";
import emp5 from "../Imges/creativeDesign.jpg";

const Third = () => {
  const [inView, setInView] = useState(false);
  const sectionRef = useRef(null);

  const services = [
    {
      title: "OFFSET PRINTING",
      description: "All types of Leaflet, Brochures, Catalogue, Stationary Printing",
      image: emp1,
    },
    {
      title: "WEB PRINTING",
      description: "All types of Leaflet, Brochures, Catalogue, Stationary Printing",
      image: emp3,
    },
    {
      title: "DIGITAL PRINTING",
      description: "High-quality digital prints for all your needs",
      image: emp4,
    },
    {
      title: "CREATIVE DESIGN",
      description: "Innovative & Eye Catching Designing for Print as well as visual media",
      image: emp5,
    },
  ];

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        setInView(entry.isIntersecting);
      },
      { threshold: 0.3 }
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => {
      if (sectionRef.current) {
        observer.unobserve(sectionRef.current);
      }
    };
  }, []);

  return (
    <div className="success-section" ref={sectionRef}>
      <motion.h2
        className="section-title"
        initial={{ opacity: 0, y: 50 }}
        animate={inView ? { opacity: 1, y: 0 } : { opacity: 0, y: 50 }}
        transition={{ duration: 0.8 }}
 style={{ fontFamily: 'Montserrat, sans-serif' }}

      >
        <span>|</span> OUR Services <span>|</span>
      </motion.h2>

      <div className="card-grid">
        {services.map((service, index) => (
          <motion.div
            key={index}
            className="success-card"
            initial={{ opacity: 0, scale: 0.9 }}
            animate={inView ? { opacity: 1, scale: 1 } : { opacity: 0, scale: 0.9 }}
            transition={{ duration: 0.6, delay: index * 0.2 }}
          >
            <img src={service.image} alt={service.title} />
            <h3 style={{ fontFamily: 'Montserrat, sans-serif' }}>{service.title}</h3>
            <p style={{ fontFamily: 'Montserrat, sans-serif' }}>{service.description}</p>
          </motion.div>
        ))}
      </div>
    </div>
  );
};

export default Third;
